<template>
    <div>

        <h1 class="mt-4" v-if="deal_title === ''"><a href="/deals">Deals</a> / Ny deal</h1>
        <h1 class="mt-4" v-if="deal_title !== ''"><a href="/deals">Deals</a> / {{ deal_title }}</h1>

        <div class="content-container" v-if="fetcher.initialized">

            <div class="row">
                <div class="col-24 col-md-16">

                    <div class="custom-form-section mb-10">
                        <input-text
                            type="text"
                            name="title"
                            label="Titel"
                            class="mb-7"
                            v-model="deal.title"
                            customErrorMessage="Ange en titel"
                        />

                        <input-text
                            type="text"
                            name="company_name"
                            label="Företagsnamn"
                            class="mb-7"
                            v-model="deal.company_name"
                        />
                    </div>

                    <div class="custom-form-section">
                        <h3 class="mb-7">Publicering</h3>
                        <div class="row">
                            <div class="col-8">
                                <input-check-radio
                                    type="checkbox"
                                    name="is_public"
                                    v-model="deal.is_public"
                                    label="Publicerad"
                                    :options="[
                                        {value: true, label: 'Publicerad'},
                                    ]"
                                />
                            </div>
                            <div class="col-8">
                                <div class="custom-form-group">
                                    <label for="m0w1lohd" class="form-label">Giltig från (valfritt)</label>
                                    <div class="position-relative" style="max-width: 200px;">
                                        <datepicker-new
                                            input-class="form-control"
                                            placeholder="Välj"
                                            :use-utc="false"
                                            :language="former.datepicker.locale"
                                            :monday-first="true"
                                            :format="formerDateFormat"
                                            v-model="deal.valid_from"
                                        />
                                        <div class="btn btn-close position-absolute" style="right:6px; top:8px;" v-if="deal.valid_from" @click="deal.valid_from = null"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="custom-form-group">
                                    <label for="m0w1lohd" class="form-label">Giltig till (valfritt)</label>
                                    <div class="position-relative" style="max-width: 200px;">
                                        <datepicker-new
                                            input-class="form-control"
                                            placeholder="Välj"
                                            :use-utc="false"
                                            :language="former.datepicker.locale"
                                            :monday-first="true"
                                            :format="formerDateFormat"
                                            v-model="deal.valid_to"
                                        />
                                        <div class="btn btn-close position-absolute" style="right:6px; top:8px;" v-if="deal.valid_to" @click="deal.valid_to = null"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="custom-form-section">
                        <h3 class="mb-7">Beskrivning av rabatt</h3>
                        <input-text
                            type="text"
                            name="summary"
                            label="Label (sammanfattning av rabatt)"
                            class="mb-7"
                            v-model="deal.summary"
                        />


                        <input-text-area
                            name="description_short"
                            label="Kort beskrivning (visas i lista)"
                            class="mb-7"
                            v-model="deal.description_short"
                        />


                        <label class="form-label">Lång beskrivning (visas i popup)</label>

                        <VueTrix
                            inputId="description_long"
                            v-model="deal.description_long"
                            placeholder=""
                            class="form-control mb-7"
                        />
                    </div>

                    <div class="custom-form-section">
                        <h3 class="mb-4">Rabattkod och länk</h3>
                        <input-text
                            type="text"
                            name="discount_code"
                            label="Rabattkod (valfritt, lämna annars tomt)"
                            class="mb-7"
                            v-model="deal.discount_code"
                        />

                        <input-text
                            type="text"
                            name="url"
                            label="Länk till hemsida"
                            class="mb-7"
                            v-model="deal.url"
                        />
                    </div>

                </div>

                <div class="col-24 col-md-8">
                    
                    <div class="custom-form-section">

                        <h3>Logotyp</h3>
                        <p>Ladda upp antingen en logotyp eller ett foto som innehåller logotyp eller annan grafik.</p>

                        <div class="row mb-4">

                            <div class="col-24">
                                <div class="custom-form-group">
                                    <label for="booking-clinic-title" class="form-label">Logotyp</label>
                                    <input class="form-control" type="file" id="booking-clinic-title" @change="(e) => upload(e, 'image_logo')">
                                    <div class="custom-info">Minsta storlek: 300 pixlar bred. Vit eller transparent bakgrund.</div>
                                </div>
                            </div>

                            <div class="col-24 position-relative" v-if="deal.image_logo">
                                <div class="mb-2" style="min-height: 40px;">
                                    <img :src="'/storage/deals/'+deal.image_logo" class="w-100">
                                </div>
                                <div class="position-absolute" style="top:0; right:0;" v-if="deal.image_logo">
                                    <button class="btn btn-sm btn-danger" @click="deal.image_logo = null" v-if="deal.image_logo">
                                        Ta bort logotyp
                                    </button>
                                </div>
                            </div>
                            
                        </div>

                        <div class="row">

                            <div class="col-24">
                                <div class="custom-form-group">
                                    <label for="booking-clinic-title" class="form-label">Foto</label>
                                    <input class="form-control" type="file" id="booking-clinic-title" @change="(e) => upload(e, 'image_photo')">
                                    <div class="custom-info">Minsta storlek: 750 x 340 pixlar</div>
                                </div>
                            </div>

                            <div class="col-24 position-relative" v-if="deal.image_photo">
                                <div class="mb-2" style="min-height: 40px;">
                                    <img :src="'/storage/deals/'+deal.image_photo" class="w-100">
                                </div>
                                <div class="position-absolute" style="top:0; right:0;" v-if="deal.image_photo">
                                    <button class="btn btn-sm btn-danger" @click="deal.image_photo = null">
                                        Ta bort foto
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

            <div class="d-flex justify-content-end mt-8 mb-12">
                <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Spara uppgifter
                </button>
            </div>

        </div>

    </div>
</template>

<script>

import VueTrix from 'vue-trix'

import fetcher from '../../shared/mixins/fetcher'
import patcher from '../../shared/mixins/patcher'
import axios from 'axios'

export default {

    mixins: [
        fetcher,
        patcher
    ],

    components: {
        VueTrix
    },

    props: {
        deal_id: {
            required: true
        },
        deal_title: {
            required: true
        }
    },

    data () {
        return {
            deal: null,
            fetcher: {
                autoFill: [
                    'deal'
                ]
            }
        }
    },

    methods: {
        upload (event, type) {
            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('file', files[0], files[0].name)
            formData.append('type', type)

            axios.post(
                '/deals/' + this.deal_id + '/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.deal[type] = response.data.name
                })
                .catch(error => {
                    alert('Sparing misslyckades, vänligen försök igen.')
                })
        },

        patcherSuccess (data) {
            bus.$emit(
                'notify',
                'Uppgifterna har sparats'
            )
        }
    },

    computed: {
        fetcherUrl () {
            return '/deals/' + this.deal_id + '/fetch'
        },
        patcherUrl () {
            return '/deals/' + this.deal_id
        },
        patcherData () {
            return this.deal
        }
    }
}
</script>

<style>
.trix-button-group--file-tools {
    visibility: hidden;
}

.trix-button--icon-heading-1, .trix-button--icon-quote, .trix-button--icon-code
{
    display:none;
}

</style>
